module.exports = __webpack_public_path__ + "img/permits1.f4c26248.svg";